export default function ContactCTASection() {
  return (
    <section
      className="py-20 relative overflow-hidden"
      style={{ background: 'linear-gradient(135deg, #1a0505 0%, #050505 50%, #1a0505 100%)' }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-[#B80E28]/5 to-[#9a0b21]/5 pointer-events-none"></div>
      <div className="relative z-10 max-w-3xl mx-auto px-6 text-center">
        <h2 className="text-white text-3xl md:text-4xl font-bold mb-5">
          CONTACT US - A safe, secure and fun gaming experience
        </h2>
        <p className="text-white/65 text-sm leading-7 mb-8">
          If you have any need for our services, we have 24 hours a day, every day of the year, dedicated customer service for you. Please use our LIVE CHAT to express your views, we receive your message, we will reply as soon as possible within 1~3 minutes.
        </p>
        <a
          href="https://pnggo.bet/RFLANDINGPAGEPNG"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-[#B80E28] text-white font-bold px-8 py-4 rounded-full hover:bg-[#9a0b21] transition-all duration-300 cursor-pointer whitespace-nowrap"
        >
          Join us!
        </a>
      </div>
    </section>
  );
}
